module.exports = __webpack_public_path__ + "static/media/6.6b2f508e.jpg";